import React, { useState, useCallback } from "react";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";

import { uploadDischargeTemplate } from "../api/dischargeTemplateApi";

function DischargeTemplateUpload({ updateList }) {
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      if (rejectedFiles && rejectedFiles.length > 0) {
        toast.error("Please upload a Word document (.doc or .docx)");
      } else {
        toast.error("Please select a file");
      }
      return;
    }

    const file = acceptedFiles[0];
    const validExtensions = [".doc", ".docx"];
    const hasValidExtension = validExtensions.some((ext) =>
      file.name.toLowerCase().endsWith(ext)
    );

    if (!hasValidExtension) {
      toast.error("Only .doc and .docx files are accepted");
      return;
    }

    setSelectedFile(file);
  }, []);

  const handleUpload = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!selectedFile) {
      toast.error("Please select a file first");
      return;
    }
    setUploading(true);
    uploadDischargeTemplate(selectedFile)
      .then((res) => {
        if (res?.status === "Success") {
          toast.success(res?.message || "Template Uploaded Successfully");
          const fileName = selectedFile.name;
          setSelectedFile(null);
          updateList(fileName);
        } else {
          toast.error(res?.message || "Could not upload template");
        }
      })
      .catch((err) => {
        console.error("uploadDischargeTemplate:", err);
        toast.error(err?.response?.data?.message || "Could not upload template");
      })
      .finally(() => setUploading(false));
  }, [selectedFile, updateList]);

  return (
    <div>
      <div className="col-sm-12 col-md-12 col-lg-10" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50" style={{ marginTop: "50px" }}>
          <h4 style={{ textAlign: "center" }}>Upload Discharge Template</h4>
          <form className="contact-panel__form">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <label htmlFor="template_file" className="required-label">
                  Template File
                </label>
                <div className="form-group">
                  <Dropzone onDrop={onDrop} disabled={uploading}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        {...getRootProps()}
                        style={{
                          border: `2px dashed ${selectedFile ? "#0E3F66" : "#ccc"}`,
                          borderRadius: "8px",
                          padding: "40px",
                          textAlign: "center",
                          cursor: uploading ? "not-allowed" : "pointer",
                          backgroundColor: uploading ? "#f5f5f5" : selectedFile ? "#eef4fb" : "#fafafa",
                        }}
                      >
                        <input {...getInputProps()} />
                        {selectedFile ? (
                          <p style={{ color: "#0E3F66", fontWeight: 500, margin: 0 }}>
                            Selected: <strong>{selectedFile.name}</strong>
                          </p>
                        ) : (
                          <p style={{ margin: 0 }}>
                            Drag and drop a Word template file here, or click to select
                          </p>
                        )}
                        <p style={{ fontSize: "12px", color: "#666", marginTop: "8px", marginBottom: 0 }}>
                          (Accepted: .doc, .docx)
                        </p>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </div>

              <div className="col-12 d-flex" style={{ padding: "0px" }}>
                <div className="col-6">
                  <button
                    type="button"
                    disabled={uploading || !selectedFile}
                    onClick={handleUpload}
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      backgroundColor: "#0E3F66",
                      color: "#FFFFFF",
                      borderRadius: "10px",
                      padding: "24px 140px",
                      gap: "10px",
                      cursor: uploading || !selectedFile ? "not-allowed" : "pointer",
                      opacity: uploading || !selectedFile ? 0.6 : 1,
                    }}
                  >
                    <span>{uploading ? "Uploading..." : "Upload"}</span>
                    {!uploading && <i className="icon-arrow-right"></i>}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DischargeTemplateUpload);
